module.exports = __webpack_public_path__ + "img/1517359616.fdf7626d.jpg";